import { render, staticRenderFns } from "./SharingItem.vue?vue&type=template&id=1f2244c9&scoped=true"
import script from "./SharingItem.vue?vue&type=script&lang=js"
export * from "./SharingItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2244c9",
  null
  
)

export default component.exports